module.exports = __webpack_public_path__ + "img/service-and-shop-filter-lincoln.62798db9.jpg";